import React, { useEffect, useMemo, useRef, useState } from "react";
import selectArrow from "../../../../../assets/images/components/common/select_arrow.svg";
import "./SelectBox.scss";

const SelectBox = (props) => {
  const {
    selectBoxName,
    columnDescr,
    isWithCheckboxes = false,
    firstElIsAll = false,
    autoSelectFirst = true,
    items = [],
    sortingFunc,
    actionOnSelect,
    actionOnCheck,
    className,
  } = props;

  const wrapRef = useRef(null);
  const initSelectionRef = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [listState, setListState] = useState([]);

  useEffect(() => {
    const sourceList = Array.isArray(items) ? items : [];
    const sorted = sortingFunc
      ? [...sourceList].sort(sortingFunc)
      : sourceList;
    const nextList = firstElIsAll
      ? [{ name: "Всі", value: 0 }, ...sorted]
      : sorted;
    setListState(nextList);
    initSelectionRef.current = false;
  }, [items, firstElIsAll, sortingFunc]);

  const selectedItem = useMemo(
    () => listState.find((item) => item.value === selectedValue),
    [listState, selectedValue],
  );

  useEffect(() => {
    if (!listState.length) {
      setSelectedValue(null);
      return;
    }
    const exists = listState.some((item) => item.value === selectedValue);
    if (!exists) {
      if (autoSelectFirst && !initSelectionRef.current) {
        initSelectionRef.current = true;
        handleSelect(listState[0], true);
      } else {
        setSelectedValue(null);
      }
    }
  }, [listState, autoSelectFirst]);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (!wrapRef.current || wrapRef.current.contains(event.target)) return;
      setIsOpen(false);
    };
    if (isOpen) {
      document.addEventListener("mousedown", onClickOutside);
    }
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [isOpen]);

  const handleSelect = async (item, isInit = false) => {
    let allowed = true;
    if (actionOnSelect) {
      try {
        const res = await actionOnSelect(item);
        allowed = res !== false;
      } catch (e) {
        allowed = false;
      }
    }
    if (!allowed) return;
    setSelectedValue(item.value);
    if (!isInit) setIsOpen(false);
  };

  const handleCheck = async (event, item) => {
    event.stopPropagation();
    if (!isWithCheckboxes) return;
    if (firstElIsAll && item.value === 0) return;
    const nextValue = !item.checkboxIsActive;
    let allowed = true;
    if (actionOnCheck) {
      try {
        const res = await actionOnCheck(item, nextValue);
        allowed = res !== false;
      } catch (e) {
        allowed = false;
      }
    }
    if (!allowed) return;
    setListState((prev) =>
      prev.map((el) =>
        el.value === item.value
          ? { ...el, checkboxIsActive: nextValue }
          : el,
      ),
    );
  };

  const toggleOpen = () => setIsOpen((prev) => !prev);

  const showMenuHead =
    (columnDescr && columnDescr.namesDescr) ||
    (isWithCheckboxes && columnDescr && columnDescr.checkboxesDescr);

  return (
    <div
      className={`JoinPosterSelectBox${isOpen ? " open" : ""}${
        className ? ` ${className}` : ""
      }`}
      ref={wrapRef}
    >
      {selectBoxName && (
        <div className="JoinPosterSelectBox__label">{selectBoxName}</div>
      )}
      <button
        type="button"
        className="JoinPosterSelectBox__control"
        onClick={toggleOpen}
      >
        <span
          className={`JoinPosterSelectBox__value${
            selectedItem ? "" : " placeholder"
          }`}
        >
          {selectedItem ? selectedItem.name : "Оберіть"}
        </span>
        <img className="JoinPosterSelectBox__arrow" src={selectArrow} alt="" />
      </button>
      {isOpen && (
        <div className="JoinPosterSelectBox__menu">
          {showMenuHead && (
            <div
              className={`JoinPosterSelectBox__menuHead${
                isWithCheckboxes ? " with-checkboxes" : ""
              }`}
            >
              <span>{columnDescr && columnDescr.namesDescr}</span>
              {isWithCheckboxes && (
                <span>{columnDescr && columnDescr.checkboxesDescr}</span>
              )}
            </div>
          )}
          <div className="JoinPosterSelectBox__options">
            {listState.map((item, index) => {
              const isSelected = item.value === selectedValue;
              const indentStyle = item.level
                ? { paddingLeft: `${item.level * 14}px` }
                : undefined;
              return (
                <div
                  key={`${item.value}-${index}`}
                  className={`JoinPosterSelectBox__option${
                    isSelected ? " selected" : ""
                  }`}
                  onClick={() => handleSelect(item)}
                >
                  <span
                    className="JoinPosterSelectBox__optionName"
                    style={indentStyle}
                  >
                    {item.name}
                  </span>
                  {isWithCheckboxes &&
                    (!firstElIsAll || item.value !== 0) && (
                      <label
                        className={`JoinPosterSelectBox__checkbox${
                          item.checkboxIsActive ? " active" : ""
                        }`}
                        onClick={(event) => event.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          checked={!!item.checkboxIsActive}
                          onChange={(event) => handleCheck(event, item)}
                        />
                        <span />
                      </label>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectBox;
